<script setup lang="ts">
import BaseRadioGroup from '@/components/ui/BaseRadioGroup.vue';
import BaseRadio from '@/components/ui/BaseRadio.vue';
import { $t } from '@/composables/translations/useTranslate';

/**
 * Invoice Recipient Selection Component
 *
 * Allows user to select whether they are traveling or just the invoice recipient.
 * - 'solo': Contact person is traveling
 * - 'accompany': Contact person is NOT traveling (only receives invoice)
 *
 * This selection determines whether traveler forms need to be filled out.
 */

interface Props {
  modelValue: 'solo' | 'accompany';
}

defineProps<Props>();

const emit = defineEmits<{
  'update:modelValue': [value: 'solo' | 'accompany'];
}>();

function handleUpdate(value: string | number | boolean) {
  emit('update:modelValue', value as 'solo' | 'accompany');
}
</script>

<template>
  <div class="checkout-invoice-recipient mb-12">
    <h3 class="h3-styling mb-6 text-text-primary">
      {{ $t('ibe.checkout.traveler.title-1', 'Traveler 1') }}
    </h3>

    <BaseRadioGroup
      name="invoice-recipient"
      :model-value="modelValue"
      @update:model-value="handleUpdate"
    >
      <BaseRadio
        id="invoice-recipient-solo"
        name="invoice-recipient"
        value="solo"
        :label="$t('ibe.checkout.invoice-recipient.solo', 'I am traveling')"
        :model-value="modelValue"
      />

      <BaseRadio
        id="invoice-recipient-accompany"
        name="invoice-recipient"
        value="accompany"
        :label="$t('ibe.checkout.invoice-recipient.accompany', 'I am not traveling')"
        :model-value="modelValue"
      />
    </BaseRadioGroup>
  </div>
</template>
